import React from 'react'
import Helmet from 'react-helmet'

import { getUuid } from 'utils/storage'
import isElectron from '../utils/isElectron'
import { NETWORK_ENV, FINGER_PRINT_URL_MAPPING } from '../utils/httpRequest'

const urlBase = `${FINGER_PRINT_URL_MAPPING[NETWORK_ENV]}/matomo/`
const siteId = isElectron() ? 4 : 2

export const MatomoLoader = () => {
  if (process.env.NODE_ENV !== 'production') return null
  const userId = getUuid()

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          var _paq = window._paq || [];
          _paq.push(['trackPageView']);
          _paq.push(['enableLinkTracking']);
          (function() {
          var u="${urlBase}";
          _paq.push(['setTrackerUrl', u+'matomo.php']);
          _paq.push(['setSiteId', '${siteId}']);
          _paq.push(['setUserId', '${userId}']);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
          })();
        `}
      </script>
    </Helmet>
  )
}
